interface AuditSourceReference {
  documentId: string;
  label: string;
}

const INTERNAL_ID = /\b[0-9a-f]{24}\b/gi;

/** Historic model notes may mention Mongo IDs; show the cited entry instead. */
export const displayAuditText = (text: string, sources: readonly AuditSourceReference[]): string => {
  const labels = new Map(sources.map((source) => [source.documentId.toLowerCase(), source.label]));
  return text.replace(INTERNAL_ID, (id) => {
    const label = labels.get(id.toLowerCase())?.replace(INTERNAL_ID, 'affected entry').trim();
    return label ? `“${label}”` : 'the affected entry';
  });
};
